// extracted by mini-css-extract-plugin
export default {"label":"LanguageSelect-index__label--zKZlh"};